import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { trackVisit } from "./api/analyticsAPI";

import Main from "./pages/user/main";
import BlogList from "./pages/user/blog";
import BlogPost from "./pages/user/blogPost";
import LoginForm from "./components/admin/login";
import ProtectedRoute from "./components/ProtectedRoute";

import Dashboard from "./pages/admin/dashboard";
import Certificate from "./pages/admin/certificate";
import Portofolio from "./pages/admin/portofolio";
import BlogAdmin from "./pages/admin/blog";
import ProfileAdmin from "./pages/admin/profile";
import UsersAdmin from "./pages/admin/users";
import MediaAdmin from "./pages/admin/media";
import CommentsAdmin from "./pages/admin/comments";
import N404 from "./components/404";

const PageTracker = () => {
  const location = useLocation();
  useEffect(() => {
    // only track public pages, not admin
    if (!location.pathname.startsWith("/admin")) {
      trackVisit(location.pathname);
    }
  }, [location.pathname]);
  return null;
};

const App = () => {
  return (
    <>
    <PageTracker />
    <Routes>
      <Route path="/" element={<Main />} />
      <Route path="/blog" element={<BlogList />} />
      <Route path="/blog/:slug" element={<BlogPost />} />
      <Route path="/login" element={<LoginForm />} />

      <Route path="/admin/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/admin/certificate" element={<ProtectedRoute><Certificate /></ProtectedRoute>} />
      <Route path="/admin/portofolio" element={<ProtectedRoute><Portofolio /></ProtectedRoute>} />
      <Route path="/admin/blog" element={<ProtectedRoute><BlogAdmin /></ProtectedRoute>} />
      <Route path="/admin/profile" element={<ProtectedRoute><ProfileAdmin /></ProtectedRoute>} />
      <Route path="/admin/users" element={<ProtectedRoute><UsersAdmin /></ProtectedRoute>} />
      <Route path="/admin/media" element={<ProtectedRoute><MediaAdmin /></ProtectedRoute>} />
      <Route path="/admin/comments" element={<ProtectedRoute><CommentsAdmin /></ProtectedRoute>} />

      <Route path="*" element={<N404 />} />
    </Routes>
    </>
  );
};

export default App;
